
.header {
	@apply
	yst-py-6
	yst-mb-10
	yst-text-white;
	background: linear-gradient(60deg, #5d237a 0%, #a61e69 84%, #a61e69 100%);

	.headerContainer {
		@apply
		yst-flex
		yst-flex-col
		md:yst-flex-row
		md:yst-justify-between
		yst-py-6
		md:yst-py-0;
	}

	.headerLogo {
		@apply
		yst-self-center;
	}

	.headerImage {
		@apply
		yst-hidden
		md:yst-block
		yst-mt-8
		yst-self-end;
	}
}

.stepper {
	align-items: baseline !important;

	.label {
		@apply
		yst-uppercase
		yst-text-center
		yst-max-w-20;
	}
}

.wideContent {
	@apply
	yst-max-w-4xl
	yst-px-6
	yst-mx-auto;
}

.stepContent {
	@apply
	yst-px-6
	yst-mx-auto
	yst-mt-12;
	max-width: 38rem;
}

.textCenter {
	@apply
	yst-text-center
	yst-mx-auto;
}

.ySpacing {
	@apply
	yst-space-y-6;
}

.ySmallSpacing {
	@apply
	yst-space-y-2;
}

iframe.videoFrame {
	@apply
	yst-h-[320px]
	yst-w-full;
}

.processingOrderStep {
	.spinner {
		@apply
		yst-mx-auto;
	}
}

.connectSiteStep {
	.orSeparator {
		@apply
		yst-block
		yst-mx-auto
		yst-py-1
		yst-w-36
		yst-text-center
		yst-border-y;
	}
}

.downloadingStep {
	.otherPluginAlert {
		@apply
		yst-text-slate-500;
	}

	svg.externalLinkIcon {
		@apply
		yst-h-4
		yst-ml-1;
	}
}

.buttonContainer {
	// Space out buttons if there's more than one. Otherwise, let the original ButtonContainer determine placing.
	&:has(> :nth-child(2)) {
		@apply
		yst-justify-between;
	}

	button {
		@apply
		yst-space-x-1;
	}
}

.linkGoogleAccountStep {
	.notice {
		@apply
		yst-italic;
	}
}

.sitesList {
	li {
		@apply
		yst-text-slate-600
		yst-border-t
		yst-py-3
		yst-pr-2.5;
	}

	div {
		@apply
		yst-inline-flex
		yst-justify-between
		yst-gap-4
		yst-w-full;
	}

	.purpleLink {
		color: #a61e69;
	}
}

.goToBrandInsightsLink {
	@apply
	yst-text-center
	yst-block;
	color: #a61e69;
	font-weight: 500;
	font-size: 13px;
	display: inline-flex;
	align-items: center;
}

.paper {
	@apply
	yst-p-4
	yst-border;
}

svg.buttonIcon {
	@apply
	yst-h-4
}

svg {
	path {
		stroke-width: 2px;
	}

	width: 16px;
	height: 16px;
}

.myYoastInlineLink {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}
